export const DEFAULT_OPTIONS = Object.freeze({optimize: true});
function record(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value) ? value : {};
}
export function restoreOptions(params = {}, saved = {}) {
  params = record(params);
  saved = record(saved);
  const options = {...DEFAULT_OPTIONS};
  for (const key of ['optimize']) {
    if (typeof saved[key] === 'boolean') options[key] = saved[key];
    if (params[key] !== undefined) options[key] = params[key] === '1';
  }
  const compat = params.compat !== undefined ? params.compat : saved.compat;
  if (compat === 'lua51') {
    options.compat = compat;
  }
  return options;
}
export function sourceFragment(source, options = DEFAULT_OPTIONS) {
  const restored = restoreOptions({}, options);
  // Defaults are explicit so the recipient's saved preferences cannot change
  // the program's behavior. Empty compat also clears a saved compatibility mode.
  return '#source=' + encodeURIComponent(source) +
    `&optimize=${restored.optimize ? '1' : '0'}` +
    `&compat=${restored.compat || ''}`;
}
export function storedOptions() {
  try { return record(JSON.parse(localStorage.getItem('nupp-playground-options-v1') || '{}')); }
  catch { return {}; }
}
export function saveOptions(options) {
  try { localStorage.setItem('nupp-playground-options-v1', JSON.stringify(options)); } catch {}
}
